import { reactive, computed, onBeforeMount } from '@vue/composition-api'
import store from '@/store'
import * as apiPayment from '@/api/payment'
import * as apiContract from '@/api/contract'
import { formatDateKanji } from '@/util/common'
import { processWithGettingPaymentMethodInfo, isInvoicingInformationAvailable } from '@/logic/common/CommonPaymentMethod'

export const getGroup = (props, context) => {

  onBeforeMount(() => {
    group1.init()
  })
  const group1 = reactive({
    // パッケージリスト
    packageList: [],
    // 請求書一覧表示用
    invoiceList: [],

    // WEB会員ID
    webuser_id: '',

    // 自動決済認証状態(trueの場合WEB会員情報と連携できる)
    authorization: false,

    // 申込履歴一覧ロード完了フラグ
    isApplicationHistoryLoaded: false,

    // 請求書一覧ロード完了フラグ
    isInvoicelistLoaded: false,

    /**
     * 初期表示
     */
    init: () => {
      // 初期化
      group1.isApplicationHistoryLoaded = false
      group1.isInvoicelistLoaded = false
      group1.packageList = []
      group1.authorization = false
      group1.invoiceList = []

      if (!isInvoicingInformationAvailable()) {
        // 自動決済やWEB請求書発行が有効にある前にご請求案内画面に遷移させてはいけない。
        store.dispatch('common/showErrorInFullScreen', {title: '認証エラー', text: 'このページを表示する権限がありません。'})
        return
      }

      const callback = (paymentMethodID, paymentMethodName) => {

        // 申込履歴一覧APIをコール
        const paramsApplicationHistory = {
        }
        apiContract.listApplicationHistory(paramsApplicationHistory)
          .then(response => {
            if (response) {
              const { data } = response

              const status = data.status

              if (status === 0) {
                const agreements = data.agreements

                const packageListWork = []
                for (var i = 0; i < agreements.length; i++) {
                  const payment = agreements[i].payment
                  const packageLists = agreements[i].package_lists

                  for (var k = 0; k < packageLists.length; k++) {
                    const packageName = packageLists[k].package_name ?? ''
                    let periodStart = packageLists[k].period_start ?? ''
                    let periodEnd = packageLists[k].period_end ?? ''
                    // 商品の状態
                    const productStatus = packageLists[k].product_lists[0].status ?? 0

                    if (productStatus !== 5 && productStatus !== 6 && productStatus !== 8 && productStatus !== 9) {
                      // ご請求案内で表示する項目は、商品の状態が受注済み、一部解約、終了、継続済みのみ
                      continue
                    }

                    if (periodStart !== '') {
                      periodStart = periodStart.replaceAll('-', '/')
                    }
                    if (periodEnd !== '') {
                      periodEnd = periodEnd.replaceAll('-', '/')
                    }

                    if (productStatus === 8) {
                      // 商品の状態が終了の場合は、次年度継続時の決済方法欄は表示させない（ブランクにしておく）
                      paymentMethodName = ''
                    }

                    packageListWork.push({
                      payment: payment,
                      packageName: packageName,
                      periodStart: periodStart,
                      periodEnd: periodEnd,
                      next_payment: paymentMethodName
                    })
                  }
                }
                group1.packageList = packageListWork
              }
            }
          })
          .finally(() => {
            group1.isApplicationHistoryLoaded = true
          })
      }

      // 利用者の契約情報を表示するために使用するAPIへのリクエスト処理し、
      // その後、引数で渡したコールバック処理を行う
      processWithGettingPaymentMethodInfo(callback, true)


      // 支払い方法取得APIをコール
      const parmasFetchPaymentMethod = {}
      apiPayment.fetchPaymentMethod(parmasFetchPaymentMethod)
        .then(response => {
          if (response) {
            const { data } = response

            const status = data.status

            if (status === 0) {

              // 自動決済認証状態を設定
              group1.authorization = data.authorization

              if (group1.authorization) {
                // 自動決済認証がOK(WEB会員情報と連携可能)の場合

                // 請求書一覧取得APIをコール
                const paramsInvoice = {
                  identification_code: store.state.profile.identification_code // 契約識別コード
                }
                apiPayment.listInvoices(paramsInvoice)
                  .then(response => {
                    if (response) {
                      const { data } = response
                      const status = data.status
                      if (status === 0) {
                        const list = data.lists

                        const listWork = []
                        let groupIndex = -1
                        let prevExecMonth = ''
                        for (let i = 0; i < list.length; i++) {
                          // 実行年月 (請求年月)
                          const execMonth = list[i].exec_month
                          const intExecMonth = parseInt(execMonth)
                          let execMonthStr = ''
                          if (!isNaN(intExecMonth)) {
                            const intExecMonthY = parseInt(intExecMonth / 100)
                            const intExecMonthM = intExecMonth % 100
                            execMonthStr = intExecMonthY + '年' + intExecMonthM + '月'
                          }
                          // 決済年月日 (お支払年月日)
                          const date = list[i].date

                          const webInvoiceList = list[i].web_invoice_list
                          const existWebInvoice = list[i].exist_web_invoice // WEB請求書存在フラグ
                          const webInvoiceNo = list[i].web_invoice_no // 請求書No
                          const existUsageInvoice = list[i].exist_usage_invoice // お支払い明細存在フラグ
                          const usageInvoiceNo = list[i].usage_invoice_no // お支払い明細No
                          const usageInvoiceStatus = list[i].usage_invoice_status // お支払い明細ステータス

                          if (!existWebInvoice && (!existUsageInvoice && usageInvoiceStatus !== 8)) {
                            // WEB請求書とお支払明細の両方が存在しない場合は、行を表示できないので、次のループに進む
                            // ただし、決済エラーが要因でお支払い明細が表示されない場合は行を表示する。
                            continue
                          }

                          const listNo = []
                          const listContent = []
                          const listPaymentMethod = []
                          for (let k = 0; k < webInvoiceList.length; k++) {
                            const item = webInvoiceList[k]
                            listNo.push(item.no)
                            listContent.push(item.content)
                            listPaymentMethod.push(item.payment_method)
                          }

                          const map = {
                            exec_month: execMonthStr,
                            date: formatDateKanji(date),
                            list_no: listNo,
                            list_content: listContent,
                            list_payment_method: listPaymentMethod,
                            exist_web_invoice: existWebInvoice,
                            web_invoice_no: webInvoiceNo,
                            exist_usage_invoice: existUsageInvoice,
                            usage_invoice_no: usageInvoiceNo,
                            usage_invoice_status: usageInvoiceStatus
                          }

                          if (execMonth !== prevExecMonth) {
                            groupIndex++
                          }

                          if (typeof listWork[groupIndex] === 'undefined') {
                            listWork[groupIndex] = {
                              rowspan: 0,
                              list: []
                            }
                          }
                          listWork[groupIndex].list.push(map)
                          listWork[groupIndex].rowspan = listWork[groupIndex].list.length

                          prevExecMonth = execMonth
                        }
                        group1.invoiceList = listWork 
                      }
                    }
                  })
                  .finally(() => {
                    group1.isInvoicelistLoaded = true
                  })
              }
            }
          }
        })
        .catch(() => {
          group1.isInvoicelistLoaded = true
        })

    },

    /**
     * 請求書(PDF)をクリックした場合
     * @param webInvoiceNo 請求書No
     */
    openWebInvoice: (webInvoiceNo) => {

      const identificationCode = store.state.profile.identification_code

      const params = {
        token: store.state.auth.token,
        charge_no: webInvoiceNo, // 請求No
        invoice_classification: 0 // 請求区分(0:請求書 1:ご利用代金明細)
      }
      group1.outputInvoices(params)
    },

    /**
     * お支払い明細(PDF)をクリックした場合
     * @param usageInvoiceNo お支払い明細No
     */
    openUsageInvoice: (usageInvoiceNo) => {

      const identificationCode = store.state.profile.identification_code

      const params = {
        token: store.state.auth.token,
        charge_no: usageInvoiceNo, // 請求No
        invoice_classification: 1 // 請求区分(0:請求書 1:ご利用代金明細)
      }
      group1.outputInvoices(params)
    },

    /**
     * 請求書・代金明細出力
     */
    outputInvoices: (params) => {
      const keys = Object.keys(params)
      const arr = []
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        const value = params[key]
        const str = encodeURIComponent(key) + '=' + encodeURIComponent(value)
        arr.push(str)
      }
      const query = arr.join('&')
      window.open('/lc/app-pdf/invoice.php?' + query, '_blank')
    }
  })

  const state = reactive({
  })

  return {
    group1,
    state
  }
}
